import { useAuthStore } from '../store/authStore';
import { notificationPresentation, useNotificationPreferencesStore } from '../store/notificationPreferencesStore';

const accountKey = (auth: ReturnType<typeof useAuthStore.getState>) => auth.userType === 'employee'
  ? `employee:${auth.employee?.agency?.id || ''}:${auth.employee?.id || ''}`
  : `agency:${auth.user?._id || ''}`;

export function getNotificationPresentation() {
  const key = accountKey(useAuthStore.getState());
  return notificationPresentation(useNotificationPreferencesStore.getState().accounts[key]);
}

export function useNotificationPreferences() {
  const account = useAuthStore(accountKey);
  const mode = useNotificationPreferencesStore(state => state.accounts[account] || 'full');
  const setMode = useNotificationPreferencesStore(state => state.setMode);
  return { mode, setMode: (value: typeof mode) => setMode(account, value), ...notificationPresentation(mode) };
}
